function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".icon_34_Multiple_Video_Resolutions_svg__cls-1{fill:#81858d}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "icon_34_Multiple_Video_Resolutions_svg__icon_34_Multiple_Video_Resolutions"
}, /*#__PURE__*/React.createElement("path", {
  className: "icon_34_Multiple_Video_Resolutions_svg__cls-1",
  d: "M13.73 10.22V18H2.12v-7.78h11.61m2.03-1.99H.09V20h15.67V8.22z"
}), /*#__PURE__*/React.createElement("path", {
  className: "icon_34_Multiple_Video_Resolutions_svg__cls-1",
  d: "M24 20h-6.34v-1.99h4.31V1.99H2.03v4.48H0V0h24v20z"
}), /*#__PURE__*/React.createElement("path", {
  className: "icon_34_Multiple_Video_Resolutions_svg__cls-1",
  d: "M15.48 9.91l-1.45-1.4 3.61-3.61 1.45 1.4-3.61 3.61z"
}), /*#__PURE__*/React.createElement("path", {
  className: "icon_34_Multiple_Video_Resolutions_svg__cls-1",
  d: "M20.21 10.04h-2.03V6.07h-4.2V4.08h6.23v5.96z"
}));

var SvgIcon34MultipleVideoResolutions = function SvgIcon34MultipleVideoResolutions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_34_Multiple_Video_Resolutions_svg___024_Q4",
    viewBox: "0 0 24 20"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIGlkPSJfMDI0X1E0IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyMCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiM4MTg1OGQ7fTwvc3R5bGU+PC9kZWZzPjxnIGlkPSJpY29uXzM0X011bHRpcGxlX1ZpZGVvX1Jlc29sdXRpb25zIj48Zz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0xMy43MywxMC4yMnY3Ljc4SDIuMTJ2LTcuNzhIMTMuNzNtMi4wMy0xLjk5SC4wOXYxMS43N0gxNS43NlY4LjIyaDBaIi8+PHBvbHlnb24gY2xhc3M9ImNscy0xIiBwb2ludHM9IjI0IDIwIDE3LjY2IDIwIDE3LjY2IDE4LjAxIDIxLjk3IDE4LjAxIDIxLjk3IDEuOTkgMi4wMyAxLjk5IDIuMDMgNi40NyAwIDYuNDcgMCAwIDI0IDAgMjQgMjAiLz48cG9seWdvbiBjbGFzcz0iY2xzLTEiIHBvaW50cz0iMTUuNDggOS45MSAxNC4wMyA4LjUxIDE3LjY0IDQuOSAxOS4wOSA2LjMgMTUuNDggOS45MSIvPjxwb2x5Z29uIGNsYXNzPSJjbHMtMSIgcG9pbnRzPSIyMC4yMSAxMC4wNCAxOC4xOCAxMC4wNCAxOC4xOCA2LjA3IDEzLjk4IDYuMDcgMTMuOTggNC4wOCAyMC4yMSA0LjA4IDIwLjIxIDEwLjA0Ii8+PC9nPjwvZz48L3N2Zz4=";
export { SvgIcon34MultipleVideoResolutions as ReactComponent };